import { Grid, styled } from "@mui/material";

export const GridStyled = styled(Grid)`
	img {
		display: block;
		margin: auto;
	}
`;
